module.exports = __webpack_public_path__ + "static/favicon-cc791522ed283c090ca95fa132144e83.ico";